import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
  return localStorage.getItem("companyId");
}


export async function getAllData() {
  const companyId = getCompanyId();
    const { data, error } = await supabase.from('taskmanageview').select().eq("isActive", true).eq('companyId',companyId);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getIdData(id) {
    const { data, error } = await supabase.from('taskmanageview').select()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getStudentIdData(id) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('taskmanageview').select()
    .eq('to', id)
    .eq("isActive", true)
    .eq('companyId',companyId)
    .order('status', { ascending: false })
    .order('subject', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getStudentIdDataWithStatus(id,statusway) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('taskmanageview').select()
    .eq('to', id)
    .eq('companyId',companyId)
    .eq('statusway',statusway)
    .order('statusway', { ascending: true })
    .order('subject', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getInstructorData(id) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('taskmanageview').select()
    .or(`from.eq.${id},subinstructorId.eq.${id}`)
    //.order('status', { ascending: false })
    .eq('companyId',companyId)
    .eq("isActive", true)
    .order('subject', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getInstructorDataWithStatus(id,status) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('taskmanageview').select()
    .or(`from.eq.${id},subinstructorId.eq.${id}`)    
    .eq('status',status)
    .eq('companyId',companyId)
    //.order('status', { ascending: false })
    .order('subject', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getInstructorDataWithClass(id,clas) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('taskmanageview').select()
    .or(`from.eq.${id},subinstructorId.eq.${id}`)
    .eq('classId',clas)
    .eq('companyId',companyId)
    //.order('status', { ascending: false })
     .eq("isActive", true)
    .order('subject', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getInstructorwithStudentData(instructor,student) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('taskmanageview').select()
    //.eq('from', instructor)
    .or(`from.eq.${instructor},subinstructorId.eq.${instructor}`)
    .eq('to', student)
    .eq('companyId',companyId)
    //.order('status', { ascending: false })
    // .eq("isActive", true)
    .order('subject', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getInstructorwithStudentDataWithStatus(instructor,student,statusway) {
   //if(isCurrent === 0)
   //{ 
   const companyId = getCompanyId();

    const { data, error } = await supabase.from('taskmanageview').select()
    .or(`from.eq.${instructor},subinstructorId.eq.${instructor}`)
    .eq('to', student)
    .eq('statusway',statusway)
    .eq('companyId',companyId)
    .order('subject', { ascending: true });

    console.log("data",data,error);
    
    if (error) {
      console.log("error",error);
      throw new Error('Failed to fetch data')
    }

    return data;
    /*
  }
    else
    { 
      let isCurrentStatus = false;
      if (isCurrent === 1)
        isCurrentStatus = true

      const { data, error } = await supabase.from('taskmanageview').select()
    .eq('from', instructor)
    .eq('to', student)
    .eq('status',status)
    .eq('isCurrent',isCurrentStatus);


    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;}
    */
  }


  export async function addData(adata) {
    const { data, error } = await supabase.from('taskmanageview').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    console.log("udata",udata);
    const { data, error } = await supabase.from('taskmanageview').update(udata).eq('id', udata.id).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('taskmanageview').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

